import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { HomeIcon } from '@moia-dev/pace-icons'
import { HubsAreaRoutes } from './HubsAreaRoutes'

export const HubsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={HubsAreaRoutes.List.route}
      Icon={HomeIcon}
    />
  )
}
